var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopTable',{attrs:{"title":_vm.date_time + ' 考勤详情',"list":_vm.details.list,"columns":_vm.pop_columns,"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }